import * as locations from './actions';
import { LocationState } from './types';
import { ActionType } from 'typesafe-actions';
import { Middleware } from 'redux';

export const fetchLocationsMiddleware: Middleware<{}, LocationState> = ({ getState }) => next => async (action: ActionType<typeof locations>) => {
  next(action);
  // return;

  // if (action.type != getType(locations.updateLocations)) {
  //   return;
  // }

  // next(locations.fetchLocations.request());
  // try {
  //   const response = await fetch('/data/locations.json');
  //   const json = await response.json();
  //   const list: Location[] = [];
  //   json.data.forEach((item: any) => {
  //     const coordinates = item.latLong.split(',');
  //     const lat = Number(coordinates[0].replace('lat:', ''));
  //     const lng = Number(coordinates[1].replace('long:', ''));
  //     list.push({
  //       id: item.id,
  //       name: item.name,
  //       parkCode: item.parkCode,
  //       lat,
  //       lng,
  //     });
  //   });
  //   console.log(list);
  //   const locationsList: Location[] = json;

  //   next(locations.fetchLocations.success(locationsList));
  // } catch (e) {
  //   next(locations.fetchLocations.failure(e));
  // }
};
